import { render, staticRenderFns } from "./assetValueChange.vue?vue&type=template&id=4c3a8d7f&scoped=true&"
import script from "./assetValueChange.vue?vue&type=script&lang=js&"
export * from "./assetValueChange.vue?vue&type=script&lang=js&"
import style0 from "./assetValueChange.vue?vue&type=style&index=0&id=4c3a8d7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a8d7f",
  null
  
)

export default component.exports